/*
 * Lunivea Bundle
 * ------------------------------------------------------------
 * 1) Koppelt die vier Geschenke an das Lunivea Pilates Board:
 *    - Ernährungsratgeber, 4-Wochen-Kurs: immer genau 1x,
 *      sobald mindestens ein Board im Warenkorb liegt.
 *    - Premium Versand: Menge = Board-Menge.
 *    - Kniematte (Geschenk): Menge = Board-Menge (Minimum), Farbe passend zur Board-Variante.
 *      Der Kunde darf die Kniematte-Menge erhöhen.
 *    - Liegt kein Board mehr im Warenkorb, verschwinden alle Geschenk-Zeilen.
 *    - Geschenk-Zeilen tragen die versteckte Eigenschaft `_lunivea_bundle`.
 *      Eine zusätzlich gekaufte Kniematte (ohne diese Eigenschaft) bleibt unberührt.
 *
 * 2) Begrenzt das Warenkorb-Ereignis (Meta "AddToCart", Shopify
 *    "product_added_to_cart") auf genau EINS pro Sitzung:
 *    - Shopify erkennt Warenkorb-Änderungen, indem es window.fetch und
 *      XMLHttpRequest im Hauptfenster abfängt.
 *    - Der erste Hinzufügen-Vorgang einer Sitzung läuft über das (von Shopify
 *      beobachtete) window.fetch und wird gemeldet. Alle weiteren Warenkorb-
 *      Schreibzugriffe – Geschenke, Mengenänderungen, Quick-Add, Upsells,
 *      Apps – laufen über ein unverändertes fetch/XHR aus einem leeren iframe
 *      und werden nicht gemeldet.
 *    - Die Schleuse ist global: window.fetch und window.XMLHttpRequest werden
 *      nach dem Laden der Seite (also NACH Shopifys Pixel-Hook) umhüllt, damit
 *      auch Skripte erfasst werden, die nicht durch product-form.js laufen.
 *    - Eine Sitzung endet nach 30 Minuten ohne Warenkorb-Aktivität.
 *
 * Rabatte werden hier NICHT gesetzt – das übernimmt ein automatischer
 * Rabatt im Shopify-Admin.
 */
(function () {
  'use strict';

  if (window.LuniveaBundle) return;

  var CONFIG = {
    boardProductId: 10537081798993,
    marker: '_lunivea_bundle',
    markerValue: 'board',
    singleGifts: [
      54733169394001, // Lunivea Ernährungsratgeber
      54733154222417  // Lunivea 4-Wochen-Einstiegskurs
    ],
    perBoardGifts: [
      54733172801873  // Lunivea Premium Versand (1x pro Board)
    ],
    matteByBoardVariant: {
      52711167230289: 54733150945617, // Board Babyblau -> Kniematte Lila
      52711167263057: 54733150912849, // Board Schwarz  -> Kniematte Schwarz
      52711167295825: 54733150978385  // Board Rosa     -> Kniematte Rosa
    },
    matteFallback: 54733150945617,
    sessionMinutes: 30,
    storageKey: 'lunivea_atc_session',
    failCooldownMs: 60000,
    debug: false
  };

  var log = function () {
    if (CONFIG.debug && window.console) console.log.apply(console, ['[LuniveaBundle]'].concat([].slice.call(arguments)));
  };

  // Das Theme deklariert PUB_SUB_EVENTS mit `const` (kein window-Property) und
  // subscribe/publish als globale Funktionen – deshalb über typeof auflösen.
  function pubsub() {
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    var sub = typeof subscribe === 'function' ? subscribe : window.subscribe;
    var pub = typeof publish === 'function' ? publish : window.publish;
    if (!events || !events.cartUpdate || typeof sub !== 'function' || typeof pub !== 'function') return null;
    return { events: events, subscribe: sub, publish: pub };
  }

  var routes = window.routes || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = routes.cart_url || (ROOT + 'cart');
  var CART_ADD_URL = routes.cart_add_url || (ROOT + 'cart/add');
  var CART_CHANGE_URL = routes.cart_change_url || (ROOT + 'cart/change');

  /* ------------------------------------------------------------------
   * Sitzung (ein AddToCart pro Sitzung)
   * ---------------------------------------------------------------- */
  var memorySession = null;

  function readSession() {
    try {
      var raw = window.localStorage.getItem(CONFIG.storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return memorySession;
    }
  }

  function writeSession(s) {
    memorySession = s;
    try {
      window.localStorage.setItem(CONFIG.storageKey, JSON.stringify(s));
    } catch (e) { /* privater Modus o.ä. */ }
  }

  function sessionActive(s) {
    return !!(s && typeof s.ts === 'number' && (Date.now() - s.ts) < CONFIG.sessionMinutes * 60000);
  }

  function sessionFired() {
    var s = readSession();
    return sessionActive(s) && s.fired === true;
  }

  // Verlängert die Sitzung; `fired` wird nur gesetzt, nie zurückgenommen,
  // solange die Sitzung aktiv ist.
  function touchSession(fired) {
    var s = readSession();
    var active = sessionActive(s);
    writeSession({ ts: Date.now(), fired: (active && s.fired === true) || fired === true });
  }

  /* ------------------------------------------------------------------
   * Unbeobachtetes fetch (leeres iframe, gleiche Cookies, gleiche Origin)
   * ---------------------------------------------------------------- */
  var frame = null;

  function cleanWindow() {
    if (frame && frame.contentWindow && document.documentElement.contains(frame)) return frame.contentWindow;
    frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('title', 'Lunivea Bundle');
    frame.tabIndex = -1;
    frame.src = 'about:blank';
    frame.style.cssText = 'display:none!important;position:absolute;width:0;height:0;border:0;';
    (document.body || document.documentElement).appendChild(frame);
    return frame.contentWindow;
  }

  function absoluteUrl(url) {
    try { return new URL(String(url), window.location.href).href; } catch (e) { return String(url); }
  }

  function withCredentials(options) {
    var o = Object.assign({}, options || {});
    if (!o.credentials) o.credentials = 'same-origin';
    return o;
  }

  // Unverändertes fetch des Hauptfensters (vor jeder Umhüllung) als letzte Rückfallebene.
  var nativeFetch = window.fetch;

  function silentFetch(url, options) {
    try {
      var w = cleanWindow();
      if (w && typeof w.fetch === 'function') {
        return w.fetch(absoluteUrl(url), withCredentials(options));
      }
    } catch (e) {
      log('silentFetch fallback', e);
    }
    return nativeFetch.call(window, url, options);
  }

  /*
   * Zentrale Schleuse für alle Warenkorb-Schreibzugriffe des Themes.
   * hint.increase === true  -> die Änderung erhöht eine Menge (zählt als "hinzufügen")
   */
  function cartFetch(url, options, hint) {
    hint = hint || {};
    var u = String(url);
    var isAdd = /\/cart\/add/.test(u);
    var isChange = /\/cart\/(change|update)/.test(u);
    var addLike = isAdd || (isChange && hint.increase === true);

    if (addLike && !sessionFired()) {
      log('tracked cart call', u);
      return window.fetch(url, options).then(function (res) {
        touchSession(!!(res && res.ok));
        return res;
      });
    }
    touchSession(false);
    log('silent cart call', u);
    return silentFetch(url, options);
  }

  /* ------------------------------------------------------------------
   * Globale Schleuse (fetch + XMLHttpRequest im Hauptfenster)
   * Erfasst auch Quick-Add, Upsells, Mengen-Staffeln und App-Skripte.
   * ---------------------------------------------------------------- */
  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(url));
  }

  var guardedFetch = null;

  function installFetchGuard() {
    var current = window.fetch;
    if (typeof current !== 'function' || current === guardedFetch) return;
    var inner = current; // ggf. bereits von Shopifys Pixel-Manager umhüllt -> wird gemeldet

    guardedFetch = function (input, init) {
      var isReq = !!(input && typeof input === 'object' && typeof input.url === 'string');
      var url = isReq ? input.url : input;
      var method = String((init && init.method) || (isReq && input.method) || 'GET').toUpperCase();

      if (method === 'POST' && isCartWrite(url)) {
        if (!sessionFired()) {
          log('tracked (global)', url);
          return inner.call(window, input, init).then(function (res) {
            touchSession(!!(res && res.ok));
            return res;
          });
        }
        touchSession(false);
        var w = null;
        try { w = cleanWindow(); } catch (e) { /* ignore */ }
        if (w && typeof w.fetch === 'function') {
          log('silent (global)', url);
          if (!isReq) return w.fetch(absoluteUrl(url), withCredentials(init));
          // Request-Objekte gelten nur im eigenen Fenster -> in URL + Optionen übersetzen
          var req = input;
          return req.clone().blob().then(function (body) {
            var o = withCredentials(init);
            if (!o.method) o.method = req.method;
            if (!o.headers) o.headers = req.headers;
            if (!o.body && req.method !== 'GET' && req.method !== 'HEAD') o.body = body;
            return w.fetch(absoluteUrl(req.url), o);
          });
        }
      }
      return inner.call(window, input, init);
    };
    guardedFetch.__lunivea = true;
    window.fetch = guardedFetch;
  }

  var GuardedXHR = null;

  function installXhrGuard() {
    var Current = window.XMLHttpRequest;
    if (typeof Current !== 'function' || Current === GuardedXHR || typeof Proxy !== 'function') return;

    GuardedXHR = function () {
      var inner = new Current();
      var pre = [];            // vor open() gesetzte Eigenschaften/Listener
      var swapped = false;
      var target = Object.create(Current.prototype);

      return new Proxy(target, {
        get: function (_, prop) {
          if (prop === 'open') {
            return function (method, url) {
              var args = [].slice.call(arguments);
              try {
                if (!swapped && String(method).toUpperCase() === 'POST' && isCartWrite(url)) {
                  if (!sessionFired()) {
                    inner.addEventListener('loadend', function () {
                      touchSession(inner.status >= 200 && inner.status < 300);
                    });
                  } else {
                    var w = cleanWindow();
                    if (w && typeof w.XMLHttpRequest === 'function') {
                      inner = new w.XMLHttpRequest();
                      pre.forEach(function (p) {
                        if (p[0] === 'on') inner.addEventListener(p[1], p[2], p[3]);
                        else { try { inner[p[1]] = p[2]; } catch (e) { /* ignore */ } }
                      });
                      args[1] = absoluteUrl(url);
                      swapped = true;
                      touchSession(false);
                      log('silent (xhr)', url);
                    }
                  }
                }
              } catch (e) { log('xhr guard', e); }
              return inner.open.apply(inner, args);
            };
          }
          if (prop === 'addEventListener') {
            return function (type, fn, opts) {
              pre.push(['on', type, fn, opts]);
              return inner.addEventListener(type, fn, opts);
            };
          }
          var v = inner[prop];
          return typeof v === 'function' ? v.bind(inner) : v;
        },
        set: function (_, prop, value) {
          pre.push(['set', prop, value]);
          try { inner[prop] = value; } catch (e) { /* ignore */ }
          return true;
        }
      });
    };
    GuardedXHR.prototype = Current.prototype;
    ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (k) { GuardedXHR[k] = Current[k]; });
    GuardedXHR.__lunivea = true;
    window.XMLHttpRequest = GuardedXHR;
  }

  function installGuards() {
    try { installFetchGuard(); } catch (e) { log('fetch guard', e); }
    try { installXhrGuard(); } catch (e) { log('xhr guard', e); }
  }

  // Shopifys Pixel-Hook wird asynchron installiert. Die Schleuse muss die
  // äußerste Hülle sein, daher nach dem Laden installieren und eine Weile
  // nachprüfen, ob jemand window.fetch/XMLHttpRequest erneut ersetzt hat.
  function scheduleGuards() {
    var started = Date.now();
    var timer = setInterval(function () {
      installGuards();
      if (Date.now() - started > 20000) {
        clearInterval(timer);
        setInterval(installGuards, 5000);
      }
    }, 500);
  }

  /* ------------------------------------------------------------------
   * Warenkorb lesen / Soll-Zustand berechnen
   * ---------------------------------------------------------------- */
  function getCart() {
    return window.fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties[CONFIG.marker] === CONFIG.markerValue);
  }

  function isBoardLine(item) {
    return !!item && Number(item.product_id) === CONFIG.boardProductId && !isGiftLine(item);
  }

  function computeDesired(cart) {
    var desired = {}; // variantId -> quantity
    var boardTotal = 0;
    (cart.items || []).forEach(function (item) {
      if (!isBoardLine(item)) return;
      boardTotal += item.quantity;
      var matte = CONFIG.matteByBoardVariant[item.variant_id] || CONFIG.matteFallback;
      desired[matte] = (desired[matte] || 0) + item.quantity;
    });
    if (boardTotal > 0) {
      CONFIG.singleGifts.forEach(function (v) { desired[v] = 1; });
      CONFIG.perBoardGifts.forEach(function (v) { desired[v] = boardTotal; });
    }
    return { desired: desired, boardTotal: boardTotal };
  }

  var failedUntil = {}; // variantId -> timestamp (Geschenk vorübergehend nicht hinzufügbar)

  function planOps(cart) {
    var plan = computeDesired(cart);
    var desired = plan.desired;
    var handled = {};
    var ops = [];

    // Kniematte: Kunde darf die Menge erhöhen (Minimum = Board-Menge).
    // Sinkt die Board-Menge, wird die Matte wieder auf den Soll-Wert gesetzt.
    var prevBoards = null;
    try {
      var rawPrev = window.localStorage.getItem('lunivea_board_total');
      prevBoards = rawPrev === null ? null : Number(rawPrev);
    } catch (e) { /* ignore */ }
    var boardsDropped = prevBoards !== null && !isNaN(prevBoards) && plan.boardTotal < prevBoards;
    try { window.localStorage.setItem('lunivea_board_total', String(plan.boardTotal)); } catch (e) { /* ignore */ }
    var matteIds = Object.keys(CONFIG.matteByBoardVariant).map(function (k) { return CONFIG.matteByBoardVariant[k]; });

    // Geschenk-Zeilen je Variante gruppieren. Shopify teilt eine Menge in mehrere
    // Zeilen derselben Variante (gratis + bezahlt) – die Summe zählt.
    var groups = {};
    (cart.items || []).forEach(function (item) {
      if (!isGiftLine(item)) return;
      var g = groups[item.variant_id] || (groups[item.variant_id] = { lines: [], total: 0 });
      g.lines.push(item);
      g.total += item.quantity;
    });

    Object.keys(groups).forEach(function (vid) {
      var g = groups[vid];
      var id = Number(vid);
      var want = desired[id] || 0;
      if (want > 0 && !boardsDropped && matteIds.indexOf(id) !== -1) want = Math.max(want, g.total);
      handled[vid] = true;
      if (g.total === want) return;

      if (want === 0) {
        g.lines.forEach(function (l) { ops.push({ type: 'change', key: l.key, quantity: 0, variantId: id }); });
      } else if (g.total !== want) {
        // Shopify trennt die rabattierte (gratis) und die bezahlte Menge in zwei Zeilen:
        // nur die Differenz auf der letzten Zeile ausgleichen
        var last = g.lines[g.lines.length - 1];
        ops.push({ type: 'change', key: last.key, quantity: Math.max(0, last.quantity + (want - g.total)), variantId: id });
      }
    });

    Object.keys(desired).forEach(function (variantId) {
      if (handled[variantId]) return;
      if (desired[variantId] <= 0) return;
      if (failedUntil[variantId] && failedUntil[variantId] > Date.now()) return;
      ops.push({ type: 'add', id: Number(variantId), quantity: desired[variantId] });
    });

    return { ops: ops, boardTotal: plan.boardTotal };
  }

  /* ------------------------------------------------------------------
   * Änderungen anwenden (immer unbeobachtet, nacheinander)
   * ---------------------------------------------------------------- */
  function jsonPost(url, body) {
    return silentFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function giftProperties() {
    var p = {};
    p[CONFIG.marker] = CONFIG.markerValue;
    return p;
  }

  function applyOps(ops) {
    var changes = ops.filter(function (o) { return o.type === 'change'; });
    var adds = ops.filter(function (o) { return o.type === 'add'; });
    var chain = Promise.resolve();

    changes.forEach(function (op) {
      chain = chain.then(function () {
        return jsonPost(CART_CHANGE_URL + '.js', { id: op.key, quantity: op.quantity })
          .then(function (r) { if (!r.ok) log('change failed', op, r.status); })
          .catch(function (e) { log('change error', op, e); });
      });
    });

    if (adds.length) {
      var items = adds.map(function (op) { return { id: op.id, quantity: op.quantity, properties: giftProperties() }; });
      chain = chain.then(function () {
        return jsonPost(CART_ADD_URL + '.js', { items: items }).then(function (r) {
          if (r.ok) return;
          // Einzeln nachlegen – ein nicht verfügbares Geschenk darf die anderen nicht blockieren.
          var single = Promise.resolve();
          adds.forEach(function (op) {
            single = single.then(function () {
              return jsonPost(CART_ADD_URL + '.js', { items: [{ id: op.id, quantity: op.quantity, properties: giftProperties() }] })
                .then(function (rr) { if (!rr.ok) { failedUntil[op.id] = Date.now() + CONFIG.failCooldownMs; log('gift unavailable', op.id, rr.status); } })
                .catch(function (e) { failedUntil[op.id] = Date.now() + CONFIG.failCooldownMs; log('add error', op, e); });
            });
          });
          return single;
        }).catch(function (e) { log('add error', e); });
      });
    }

    return chain;
  }

  /* ------------------------------------------------------------------
   * Darstellung aktualisieren (Drawer, Warenkorb-Seite, Icon)
   * ---------------------------------------------------------------- */
  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');
    if (mainItems && mainItems.dataset.id) ids.push(mainItems.dataset.id);
    if (mainFooter && mainFooter.dataset.id) ids.push(mainFooter.dataset.id);
    return ids;
  }

  function fetchSections(ids) {
    return window.fetch(CART_URL + '?sections=' + encodeURIComponent(ids.join(',')), { cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function renderFromSections(sections, cart) {
    var isEmpty = !cart || cart.item_count === 0;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var src = parseHtml(sections['cart-drawer']).querySelector('#CartDrawer');
      var dst = document.getElementById('CartDrawer');
      if (src && dst) {
        dst.innerHTML = src.innerHTML;
        var overlay = dst.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
      }
      drawer.classList.toggle('is-empty', isEmpty);
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parseHtml(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }

    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var s = parseHtml(sections[el.dataset.id]).querySelector('.js-contents');
      var d = el.querySelector('.js-contents');
      if (s && d) d.innerHTML = s.innerHTML;
      if (id === 'main-cart-footer') el.classList.toggle('is-empty', isEmpty);
    });

    var cartItems = document.querySelector('cart-items');
    if (cartItems) cartItems.classList.toggle('is-empty', isEmpty);

    var ps = pubsub();
    if (ps) ps.publish(ps.events.cartUpdate, { source: 'lunivea-bundle', cartData: cart });
  }

  /* ------------------------------------------------------------------
   * Sync (serialisiert, höchstens ein weiterer Lauf wird vorgemerkt)
   * ---------------------------------------------------------------- */
  var running = null;
  var queued = null;

  function doSync(options) {
    options = options || {};
    var result = { changed: false, cart: null };
    return getCart()
      .then(function (cart) {
        var plan = planOps(cart);
        if (!plan.ops.length) { result.cart = cart; return null; }
        log('ops', plan.ops);
        return applyOps(plan.ops).then(getCart).then(function (after) {
          result.changed = true;
          result.cart = after;
        });
      })
      .then(function () {
        if (result.changed && options.render !== false) {
          return fetchSections(sectionIds()).then(function (sections) {
            renderFromSections(sections, result.cart);
          }).catch(function (e) { log('render error', e); });
        }
      })
      .then(function () { return result; })
      .catch(function (e) { log('sync error', e); return result; });
  }

  function sync(options) {
    if (running) {
      if (!queued) {
        queued = running.then(function () { queued = null; return sync(options); });
      }
      return queued;
    }
    running = doSync(options).then(function (r) { running = null; return r; }, function () { running = null; return { changed: false, cart: null }; });
    return running;
  }

  /*
   * Wird von product-form.js nach einem erfolgreichen Hinzufügen aufgerufen.
   * Liefert die Antwort zurück – mit frisch gerenderten Sections, falls
   * Geschenke ergänzt wurden – damit das Theme den Drawer wie gewohnt öffnet.
   */
  function afterCartAdd(response, sectionIdsForCart) {
    return sync({ render: false }).then(function (r) {
      if (!r.changed) return response;
      var ids = sectionIdsForCart && sectionIdsForCart.length ? sectionIdsForCart : ['cart-drawer', 'cart-icon-bubble'];
      return fetchSections(ids).then(function (sections) {
        var out = Object.assign({}, response || {});
        out.sections = Object.assign({}, (response && response.sections) || {}, sections);
        return out;
      }).catch(function () { return response; });
    });
  }

  /* ------------------------------------------------------------------
   * Auslöser
   * ---------------------------------------------------------------- */
  var subscribed = false;

  function subscribeToCart() {
    if (subscribed) return true;
    var ps = pubsub();
    if (!ps) return false;
    ps.subscribe(ps.events.cartUpdate, function (event) {
      if (!event || event.source === 'lunivea-bundle' || event.source === 'product-form') return;
      sync();
    });
    subscribed = true;
    return true;
  }

  function bind() {
    if (!subscribeToCart()) {
      // pubsub.js noch nicht ausgeführt – nach dem Laden erneut versuchen.
      window.addEventListener('load', subscribeToCart, { once: true });
    }
    document.addEventListener('cart:open', function () { sync(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
    if (document.readyState === 'complete') scheduleGuards();
    else window.addEventListener('load', scheduleGuards, { once: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.LuniveaBundle = {
    config: CONFIG,
    cartFetch: cartFetch,
    silentFetch: silentFetch,
    sync: sync,
    afterCartAdd: afterCartAdd,
    isGiftLine: isGiftLine,
    sessionFired: sessionFired,
    installGuards: installGuards
  };
})();
